import { render, staticRenderFns } from "./ShareProfileModal.vue?vue&type=template&id=64760094&scoped=true"
import script from "./ShareProfileModal.vue?vue&type=script&lang=js"
export * from "./ShareProfileModal.vue?vue&type=script&lang=js"
import style0 from "./ShareProfileModal.vue?vue&type=style&index=0&id=64760094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64760094",
  null
  
)

export default component.exports